import { FunctionComponent } from 'react'
import { ChevronRight } from '@mui/icons-material'
import {
  rucksack,
  Breadcrumbs,
  Link,
  Skeleton,
  Typography,
} from '@black-bear-energy/rucksack'
import { ChecklistCategoryAPIResponse } from '@black-bear-energy/black-bear-energy-common'

export const DocumentExchangeBreadcrumbs: FunctionComponent<
  DocumentExchangeBreadcrumbsProps
> = ({ projectBreadcrumbProps, siteBreadcrumbProps, checklistCategory }) => {
  const { isCustomerRFPNamePending, customerRFPName } = projectBreadcrumbProps
  const { isSiteRFPNamePending, customerRFPId, siteRFPId, siteRFPName } =
    siteBreadcrumbProps ?? {}
  const siteRFPPath =
    customerRFPId && siteRFPId
      ? `/document-exchange/projects/${customerRFPId}/sites/${siteRFPId}`
      : undefined

  /** Use the light blue link color for hover and focus. */
  const linkStyle = {
    '&:hover, &:focus': {
      color: rucksack.palette.primary.main,
    },
  }

  return (
    <Breadcrumbs separator={<ChevronRight />}>
      <Link
        href="/document-exchange"
        color="text.primary"
        underline="hover"
        sx={linkStyle}
      >
        Document Exchange
      </Link>

      {/* Project breadcrumb */}
      {isCustomerRFPNamePending && <Skeleton width={100} />}
      {!isCustomerRFPNamePending && customerRFPName && (
        <>
          {siteBreadcrumbProps && customerRFPId ? (
            <Link
              href={`/document-exchange/projects/${customerRFPId}`}
              color="text.primary"
              underline="hover"
              sx={linkStyle}
            >
              <Typography variant="body1" color="text.primary" sx={linkStyle}>
                {customerRFPName}
              </Typography>
            </Link>
          ) : (
            <Typography variant="body1" color="text.primary">
              {customerRFPName}
            </Typography>
          )}
        </>
      )}

      {/* Site breadcrumb */}
      {isSiteRFPNamePending && <Skeleton width={100} />}
      {!isSiteRFPNamePending && siteRFPName && (
        <>
          {checklistCategory && siteRFPPath ? (
            <Link
              href={siteRFPPath}
              color="text.primary"
              underline="hover"
              sx={linkStyle}
            >
              <Typography variant="body1" color="text.primary" sx={linkStyle}>
                {siteRFPName}
              </Typography>
            </Link>
          ) : (
            <Typography variant="body1" color="text.primary">
              {siteRFPName}
            </Typography>
          )}
        </>
      )}

      {/* Checklist category breadcrumb */}
      {checklistCategory && (
        <Typography variant="body1" color="text.primary">
          {checklistCategory === ChecklistCategoryAPIResponse.Contracts
            ? 'Contracts'
            : 'Construction'}
        </Typography>
      )}
    </Breadcrumbs>
  )
}

export interface DocumentExchangeBreadcrumbsProps {
  projectBreadcrumbProps: {
    isCustomerRFPNamePending: boolean
    customerRFPName?: string
  }
  siteBreadcrumbProps?: {
    isSiteRFPNamePending: boolean
    customerRFPId: string
    siteRFPId?: string
    siteRFPName?: string
  }
  checklistCategory?: ChecklistCategoryAPIResponse
}
